import EventCard from './EventCard';
import EventsStacked from './EventsStacked';
import { Grid } from "theme-ui";
import SidePanel from './EventsSidePanel'
import { jsx } from 'theme-ui';
import React, { useState, useEffect } from 'react';
import { RRule, RRuleSet, rrulestr } from 'rrule';
import Navbar from './Navbar'

const categories = {
  'all': 'All',
  'educational': 'Educational',
  'sponsorship': 'Sponsorship/Alumni',
  'social': 'Social',
  'mtb': 'Meet the Board',
};

const navStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '20px',
};

const categoryStyle = (isActive) => ({
  cursor: 'pointer',
  padding: '10px 20px',
  borderRadius: '15px',
  margin: '0 10px',
  backgroundColor: isActive ? '#6E4884' : 'transparent',
  color: isActive ? 'white' : '#6E4884',
  fontSize: '1rem',
  fontWeight: 'bold',
});

const Events = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'bars'

  const handleEventClick = (event) => {
    setIsSidePanelOpen(true);
    setSelectedEvent(event);
  };

  const handleClosePanel = () => {
    setSelectedEvent(null);
    setIsSidePanelOpen(false);
  };

  useEffect(() => {
    const calendarId = "admin@harvardwics.com";
    const apiKey = "AIzaSyCqNLrFRwtb0cYyaaV-K-dewoO1uQCi-Eg";
    const today = new Date();
    const isoDate = today.toISOString();

    console.log(isoDate);

    const calendarUrl = `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events?key=${apiKey}&timeMin=${isoDate}`;

    fetch(calendarUrl)
      .then(response => response.json())
      .then(data => {
        const currentDate = new Date();
        const extractedEvents = data.items.map(event => {

          if (!event.start || !event.end) {
            return null;
          }
  
          let startDate = new Date(event.start.dateTime);
          let endDate = new Date(event.end.dateTime);

          if (event.recurrence) {
            const rule = rrulestr(event.recurrence[0], { dtstart: startDate });
            const nextOccurrence = rule.after(currentDate);
          
            if (!nextOccurrence) {
              return null;
            }
          
            startDate = nextOccurrence;
            if (!endDate) {
              return null;
            }
          
            endDate = new Date(
              startDate.getTime() - rule.options.dtstart.getTime() + endDate.getTime()
            );
          }          

          const day = startDate.getDate();
          const month = startDate.getMonth() + 1;
          const startTime = startDate.getHours() + ':' + (startDate.getMinutes() < 10 ? '0' : '') + startDate.getMinutes();
          const endTime = endDate.getHours() + ':' + (endDate.getMinutes() < 10 ? '0' : '') + endDate.getMinutes();
          const heading = event.summary ? event.summary : "untitled";
          const location = event.location ? event.location : "TBD";
          const category = event.colorId;
          const description = event.description;

          return {
            day,
            month,
            startTime,
            endTime,
            heading,
            startDate,
            location,
            category,
            description
          };
        }).filter(event => event !== null);

        extractedEvents.sort((a, b) => a.startDate - b.startDate);
        setEvents(extractedEvents);
      })
      .catch(error => {
        console.error('Error fetching events:', error);
        setEvents([]);
      });
  }, []);

  const [searchTerm, setSearchTerm] = useState('');
  
  const [activeCategory, setActiveCategory] = useState('all');
  const handleCategorySelect = (category) => {
    setActiveCategory(category);
    handleClosePanel();
  };

  const extractTag = (description = '') => {
    const tagMatch = description.match(/^\[(\w+)\]/);
    if (tagMatch) {
      return {
        tag: tagMatch[1].toLowerCase(),
        cleanDescription: description.replace(/^\[\w+\]\s*/, '')
      };
    }
    return { tag: 'other', cleanDescription: description };
  };
  
  const processedEvents = events.map(event => {
    const { tag, cleanDescription } = extractTag(event.description || '');
    return {
      ...event,
      category: event.category || tag,
      description: cleanDescription,
    };
  });
  
  const filteredEvents = processedEvents.filter(event => {
    const matchesCategory =
      activeCategory === 'all' || event.category === activeCategory;
  
    return (
      event.heading.toLowerCase().includes(searchTerm.toLowerCase()) &&
      matchesCategory
    );
  });
  

  return (
    <div style={{ width: '100%', display: 'flex', color: '#F9F9F9', justifyItems: 'center' }}>
    
      <div style={{ 
          padding: '5%', 
          width: isSidePanelOpen ? '80%' : '100%',
          transition: 'width 0.3s ease'
      }}>
          {/* search bar and view toggle */}
          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center' }}>
              <input
                  type="text"
                  placeholder="Search by event..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ 
                      flex: 1,
                      padding: '15px', 
                      border: '1px solid #6E4884', 
                      borderRadius: '20px', 
                      color: 'grey', 
                      boxShadow: '0px 0px 4px rgba(128, 128, 128, 0.5)',
                      fontFamily: "Poppins",
                  }}
              />
              
              {/* toggle buttons */}
              <div style={{ display: 'flex', gap: '5px', background: '#2a2a2a', borderRadius: '20px', padding: '5px' }}>
                  <button
                      onClick={() => setViewMode('cards')}
                      style={{
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '15px',
                          background: viewMode === 'cards' ? '#6E4884' : 'transparent',
                          color: '#F9F9F9',
                          cursor: 'pointer',
                          fontFamily: 'Poppins',
                          transition: 'all 0.3s ease',
                      }}
                  >
                      Cards
                  </button>
                  <button
                      onClick={() => setViewMode('bars')}
                      style={{
                          padding: '10px 20px',
                          border: 'none',
                          borderRadius: '15px',
                          background: viewMode === 'bars' ? '#6E4884' : 'transparent',
                          color: '#F9F9F9',
                          cursor: 'pointer',
                          fontFamily: 'Poppins',
                          transition: 'all 0.3s ease',
                      }}
                  >
                      Bars
                  </button>
              </div>
          </div>

          <div style={navStyle}>
             {Object.entries(categories).map(([id, name]) => (
               <div
                 key={id}
                 style={categoryStyle(activeCategory === id)}
                 onClick={() => handleCategorySelect(id)}
               >
                 {name}
               </div>
             ))}
           </div>

          {/* rendering based on view mode */}
          {viewMode === 'cards' ? (
              <Grid
                sx={{
                  flex: '1',
                  maxWidth: '100%',
                  gridTemplateColumns: [
                    '1fr',
                    isSidePanelOpen ? 'repeat(2, minmax(200px, 1fr))' : 'repeat(3, minmax(200px, 1fr))',
                  ],
                  margin: '0 auto',
                  gap: '20px',
                  padding: '20px',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',

              '@media (max-width: calc(800px))': {  // Adjust for navbar (~20%)
                gridTemplateColumns: '1fr', // Force 1 column
              },
              '@media (max-width: calc(900px))': {  // Adjust for navbar (~20%)
                gridTemplateColumns: isSidePanelOpen ? '1fr' : 'repeat(2, minmax(200px, 1fr))', // 1 or 2 columns
              },
            }}
          >

            {filteredEvents.map((event, index) => (
                  <EventCard
                    key={index}
                    heading={event.heading}
                    startTime={event.startTime}
                    endTime={event.endTime}
                    month={event.month}
                    day={event.day}
                    location={event.location}
                    category={event.category}
                    description={event.description}
                    onClick={() => handleEventClick(event)}
                  />
                ))}
              </Grid>
          ) : (
              <div style={{ padding: '20px 30px' }}>
                {filteredEvents.map((event, index) => (
                  <EventsStacked
                    key={index}
                    heading={event.heading}
                    startTime={event.startTime}
                    endTime={event.endTime}
                    month={event.month}
                    day={event.day}
                    location={event.location}
                    category={event.category}
                    description={event.description}
                    onClick={() => handleEventClick(event)}
                  />
                ))}
              </div>
          )}
      </div>

      {isSidePanelOpen && (
          <div style={{
              width: '300px', 
              transition: 'width 0.3s ease'
          }}>
              <SidePanel event={selectedEvent} onClose={handleClosePanel} />
          </div>
      )}
    </div>
  );

}

export default Events;